import { createZipFile } from "./createZipFile";

interface File {
  url: string;
  name: string;
}

export const downloadFiles = async (files: Array<File> | File) => {
  if (!Array.isArray(files)) {
    files = [files];
  }

  if (!files.length) {
    return;
  }

  const fileContents = await Promise.all(
    files.map(async (file) => {
      const blob = await fetch(file.url).then((res) => res.blob());
      return { file: blob, name: file.name };
    }),
  );

  let downloadFile;
  let downloadFileName;
  if (files.length === 1) {
    downloadFile = fileContents[0].file;
    downloadFileName = fileContents[0].name;
  } else {
    downloadFile = await createZipFile(fileContents);
    downloadFileName = `Assets ${new Date().toISOString().slice(0, 10)}.zip`;
  }

  // download a blob file
  const url = window.URL.createObjectURL(downloadFile);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", downloadFileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
